module.exports = "#header {\n  background: #eb4997;\n  min-height: 200px;\n  padding: 30px 0 20px 0; }\n"